/**
 * The path prefix the app is served under, detected at RUNTIME from the URL.
 *
 * Returns '' when the app is served at the origin root (local dev, and
 * production once it moves to `/`), and '/homework' when served under the
 * legacy prefix. Runtime rather than build-time so ONE build works at both
 * paths for as long as `/homework/*` is kept alive — see
 * docs/plans/move-app-to-root.md.
 *
 * @param {string} [pathname] - defaults to window.location.pathname
 * @returns {'' | '/homework'}
 */
const LEGACY_BASE = '/homework';

export function getAppBase(pathname = window.location.pathname) {
  return pathname === LEGACY_BASE || pathname.startsWith(`${LEGACY_BASE}/`) ? LEGACY_BASE : '';
}

/**
 * Remove the detected prefix from an app-relative path so it can be handed to
 * the router (whose basename already adds it back). '/homework' → '/'.
 *
 * @param {string} path - pathname (+ optional search) as seen in the URL bar
 * @returns {string}
 */
export function stripAppBase(path) {
  const base = getAppBase(path);
  return base ? (path.substring(base.length) || '/') : path;
}
